// Private types ---------------------------------------------------------------

type WarningAwareCustomElementConstructor = CustomElementConstructor & {
  disableWarning: (warning: string) => void
}

// Private functions -----------------------------------------------------------

// Detects Lit's development-warning control on a registered component class.
const isWarningAwareConstructor = (
  elementConstructor: CustomElementConstructor
): elementConstructor is WarningAwareCustomElementConstructor =>
  'disableWarning' in elementConstructor &&
  typeof elementConstructor.disableWarning === 'function'

// Public functions ------------------------------------------------------------

// Applies WA 3.11's validity-update allowance before existing elements upgrade.
export const setupWebAwesomeUpdateWarnings = (
  tagNames: ReadonlySet<string>
): (() => void) => {
  const defineCustomElement = customElements.define
  const defineWithPinnedWarnings: CustomElementRegistry['define'] = (
    name,
    elementConstructor,
    options
  ) => {
    if (tagNames.has(name) && isWarningAwareConstructor(elementConstructor)) {
      elementConstructor.disableWarning('change-in-update')
    }

    defineCustomElement.call(customElements, name, elementConstructor, options)
  }

  customElements.define = defineWithPinnedWarnings

  return () => {
    customElements.define = defineCustomElement
  }
}
